import React from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

// Fix for default marker icons in react-leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

const OfficeMap = () => {
  // JJ Richards office location: -27.525232, 153.252647
  const officeLocation = [-27.525232, 153.252647];
  const officeAddress = "1/3 Grant Street, Cleveland, QLD 4163, Australia";

  return (
    <div style={{ marginTop: "16px", marginBottom: "8px" }}>
      <MapContainer
        center={officeLocation}
        zoom={16}
        style={{ height: "180px", width: "100%" }}
      >
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      <Marker position={officeLocation}>
        <Popup>
          <strong>JJs Waste & Recycling</strong>
          <br />
          {officeAddress}
        </Popup>
      </Marker>
    </MapContainer>
    </div>
  );
};

export default OfficeMap;
